import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Skeleton from 'react-loading-skeleton';
import { updatecategory, getcategory, deletecategorys, } from '../../ReduxToolkit/Slice/Gallery/Category';
import 'react-loading-skeleton/dist/skeleton.css';
import Button from '../../components/Button/Button';
import PageTitle from '../../components/Title/PageTitle';
import { ToastContainer } from "react-toastify";
import Input from '../../components/Input/Input';
import AddCategory from './AddCategory';


function Category() {
    const dispatch = useDispatch();
    const closeButtonRef = useRef(null);
    const { status, categorys } = useSelector((state) => state.category);
    const [CategoryName, setCategoryName] = useState('');
    //  get
    useEffect(() => {
        if (status === "idle") {
            dispatch(getcategory());
        }
    }, [dispatch, status]);
    // delete api
    const handleDelete = (categoryid) => {
        const Isconfirmed = window.confirm("Are you sure! you want delete this Form ?")
        if (Isconfirmed) {
            dispatch(deletecategorys(categoryid))
        };
    }
    // single data fetch
    const [selectedId, setSelectedId] = useState(null);
    const handlid = (id) => {
        const selectedcategorys = categorys.data.find(plan => plan._id === id);
        setCategoryName(selectedcategorys.CategoryName);
        setSelectedId(id)

    };
    // update
    const handleEdit = (e) => {
        e.preventDefault()
        const data = {
            CategoryName
        };
        dispatch(updatecategory({ selectedId, data }))
        setCategoryName('');
        closeButtonRef.current.click();
    }
    return (
        <>
            <div>
                <ToastContainer />
                <div className='d-flex justify-content-between my-3'>
                    <PageTitle children={"categorys"} />
                    <AddCategory />
                </div>
                <div className='table-responsive'>
                    <table className="table table-hover">
                        <thead className="table-primary">
                            <tr>
                                <th scope="col">S.no</th>
                                <th scope="col">Category Name</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {status === "loading" && (
                                <tr className='my-2'>
                                    <td colSpan={8}>
                                        <Skeleton count={10} height={90} />
                                    </td>
                                </tr>
                            )}
                            {status === "failed" && (
                                <tr>
                                    <td colSpan={8}>
                                        <p className='text-center fw-bold'>{"Data not found"}</p>
                                    </td>
                                </tr>
                            )}
                            {status === "succeeded" && categorys.data && categorys.data.map((category, index) => (
                                <tr key={category._id}>
                                    <th scope="row">{index + 1}</th>
                                    <td>{category.CategoryName}</td>
                                    <td className='cursor'>
                                        <div onClick={() => handlid(category._id)}><i className='bi bi-pencil-square text-primary fs-5' data-bs-toggle="modal" data-bs-target="#exampleModal"></i></div>
                                        <div onClick={() => handleDelete(category._id)}><i className='bi bi-trash text-danger fs-5'></i></div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Modal  */}
            <div
                className="modal fade"
                id="exampleModal"
                tabIndex={-1}
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="exampleModalLabel">
                                category Form
                            </h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body">
                            <form action=""
                                onSubmit={handleEdit}
                            >
                                <Input
                                    label="Name"
                                    type="text"
                                    placeholder="Name"
                                    value={CategoryName}
                                    required
                                    onChange={(e) => setCategoryName(e.target.value)}
                                />
                                <div className={`modal-footer`}>
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        data-bs-dismiss="modal"
                                        ref={closeButtonRef}
                                    >
                                        Close
                                    </button>
                                    <Button type="submit" children={"Update"} />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Category;
